module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "note-toolbar"
    }
  }, [_vm._m(0), _vm._v(" "), _c('i', {
    staticClass: "glyphicon glyphicon-plus",
    attrs: {
      "title": "Add New Note"
    },
    on: {
      "click": function($event) {
        _vm.addNote()
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "glyphicon glyphicon-star",
    class: {
      starred: _vm.activeNote.favorite, disabled: _vm.noneActiveNote
    },
    attrs: {
      "title": "Favorite"
    },
    on: {
      "click": _vm.toggleFavorite
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "glyphicon glyphicon-remove",
    class: {
      disabled: _vm.noneActiveNote
    },
    attrs: {
      "data-toggle": "modal",
      "data-target": "#delete-modal",
      "title": "Remove Note"
    },
    on: {
      "click": _vm.checkAndSetShowAll
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    staticClass: "glyphicon logo disabled"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/logo.png"),
      "width": "30",
      "height": "30"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3581da57","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Toolbar.vue
// module id = 66
// module chunks = 1